import React, { useState, useEffect } from 'react';
import { db, storage } from '../firebaseConfig';
import { collection, getDocs, addDoc, deleteDoc, doc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';

const ManagePhotosModal = ({ eventSpaceId, onClose }) => {
  const [photos, setPhotos] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPhotos = async () => {
      if (!eventSpaceId) return; // Ensure eventSpaceId is available
      const photosCollectionRef = collection(db, 'eventSpaces', eventSpaceId, 'photos');
      try {
        const photosSnapshot = await getDocs(photosCollectionRef);
        setPhotos(photosSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })));
      } catch (err) {
        setError('Error al cargar las fotos.');
        console.error(err);
      }
    };
    fetchPhotos();
  }, [eventSpaceId]); // Depend on eventSpaceId directly

  const handlePhotoUpload = async () => {
    if (!selectedFile) {
      setError('Por favor, selecciona una imagen para subir.');
      return;
    }

    try {
      const photosCollectionRef = collection(db, 'eventSpaces', eventSpaceId, 'photos');
      const imageRef = ref(storage, `eventSpaces/${eventSpaceId}/${selectedFile.name}`);
      await uploadBytes(imageRef, selectedFile);
      const imageUrl = await getDownloadURL(imageRef);

      const docRef = await addDoc(photosCollectionRef, { imageUrl });

      setPhotos([...photos, { id: docRef.id, imageUrl }]);
      setSelectedFile(null);
      setError(null);
    } catch (err) {
      setError('Error al subir la foto.');
      console.error(err);
    }
  };

  const deletePhoto = async (id, url) => {
    try {
      const photosCollectionRef = collection(db, 'eventSpaces', eventSpaceId, 'photos');
      await deleteDoc(doc(db, 'eventSpaces', eventSpaceId, 'photos', id));

      const imageRef = ref(storage, url);
      await deleteObject(imageRef);

      setPhotos(photos.filter(photo => photo.id !== id));
    } catch (error) {
      setError('Error al eliminar la foto.');
      console.error('Error deleting photo: ', error);
    }
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '8px', width: '80%', maxWidth: '600px' }}>
        <button onClick={onClose} style={{ float: 'right' }}>Cerrar</button>
        <h2>Gestionar Fotos</h2>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <div style={{ marginBottom: '20px' }}>
          <input type="file" onChange={(e) => setSelectedFile(e.target.files[0])} />
          <button onClick={handlePhotoUpload}>Subir Foto</button>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          {photos.length === 0 ? (
            <p>No hay fotos para este salón. ¡Sube algunas!</p>
          ) : (
            photos.map(photo => (
              <div key={photo.id} style={{ position: 'relative' }}>
                <img src={photo.imageUrl} alt="Foto del salón" style={{ width: '150px', height: '100px', objectFit: 'cover' }} />
                <button onClick={() => deletePhoto(photo.id, photo.imageUrl)} style={{ position: 'absolute', top: 0, right: 0, backgroundColor: 'red', color: 'white', border: 'none', borderRadius: '50%', cursor: 'pointer' }}>X</button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ManagePhotosModal;
